import React from "react";

import { ButtonVariant, ButtonView } from "../../common/views/button/Button.view";
import HeadingView, { HeadingVariant } from "../../common/views/heading/Heading.view";
import { Fragment } from "../../core/components/FragmentProvider";
import DateLabel from "../../core/components/label/DateLabel";
import labelProvider from "./Certificates.labels";
import TokenSession from 'core/util/session/TokenSession';
import IssuedCertificate from "./entities/IssuedCertificate";
import ShareButton from "common/fragments/ShareButton";

const { Labels } = labelProvider;

export const certificateName: Fragment<IssuedCertificate> = {
	name: "Certificate Name",
	enabled: (c) => !c || !!c.certificate.name, // skeleton mode or rendered and name present
	component: (c) => (
		<HeadingView viewKey="cert-name" children={c.certificate && c.certificate.name} />
	)
};

export const productName: Fragment<IssuedCertificate> = {
	name: "Product Name",
	enabled: (c) => !c || !!c.itemName, // skeleton mode or rendered and name present
	component: (c) => (
		<HeadingView variant={HeadingVariant.H5} viewKey="item-name" children={c && c.itemName} />
	)
};

export const issueDate: Fragment<IssuedCertificate> = {
	name: "Issued Date",
	enabled: (c) => !!c && !!c.issueDate, // skeleton mode or rendered and name present
	component: (c) => (
		<DateLabel value={c && c.issueDate} />
	)
};

export const download: Fragment<IssuedCertificate> = {
	name: "Download Button",
	enabled: (c) => !c || !!c.guid, // skeleton mode or rendered and name present
	component: (c) => {
		if (c.subscription && c.subscription.credits && c.subscription.credits.length) {
			let claimed = true;
			c.subscription.credits.forEach((credit) => {
				if (credit && !credit.granted) {
					claimed = false;
				}
			})
			if (claimed) {
				return (
					<ButtonView href={c && getDownloadUrl(c)} variant={ButtonVariant.PRIMARY} viewKey="button.download">
						<Labels.Download />
					</ButtonView>
				)
			} else {
				return <React.Fragment></React.Fragment>
			}
		} else {
			return (
			<ButtonView href={c && getDownloadUrl(c)} variant={ButtonVariant.PRIMARY} viewKey="button.download">
				<Labels.Download />
			</ButtonView>
			)
		}
		
	}
};

export const shareOnLinkedInButton: Fragment<IssuedCertificate> = {
	name: "Share on LinkedIn",
	component: (c) => {
		const startTask = c.itemName;
		const name = c.certificate.name;
		const organizationName = TokenSession.getContext().name;
		const certId = c.certificate.id;
		const issueYear = new Date(c.issueDate).getFullYear();
		const issueMonth = new Date (c.issueDate).getMonth() + 1;
		const expirationYear = new Date(c.expiryDate).getFullYear();
		const expirationMonth = new Date (c.expiryDate).getMonth() + 1;
		const certUrl = getDownloadUrl(c);
		const buttonImage = "https://download.linkedin.com/desktop/add2profile/buttons/en_US.png";
		const shareUrl= `https://www.linkedin.com/profile/add?startTask=${startTask}&name=${name}&organizationName=${organizationName}&issueYear=${issueYear}&issueMonth=${issueMonth}&expirationYear=${expirationYear}&expirationMonth=${expirationMonth}&certUrl=${certUrl}s&certId=${certId}`;
		return (
		<ShareButton imgUrl={buttonImage} shareUrl={shareUrl} brand={"LinkedIn"} />
		)
	}
};

/**
 * @todo get url as field on IssuedCertificates query
 */
const getDownloadUrl = (cert: IssuedCertificate): string => `${window.location.origin}/diweb/catalog/cert/id/${cert.guid}/view/1`;



// WEBPACK FOOTER //
// ./src/panels/certificates/fragments.tsx